import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Home from '@/components/Home'
import Register from '@/components/Register'
import Login from '@/components/Login'
import People from '@/components/People'
import Contact from '@/components/Contact'
import About from '@/components/About'
import Person from '@/components/Person'
import Unit from '@/components/Unit'
import Units from '@/components/Units'
import UnitCreate from '@/components/UnitCreate'
import UnitEdit from '@/components/UnitEdit'
import Rank from '@/components/Rank'
import Ranks from '@/components/Ranks'
import RankCreate from '@/components/RankCreate'
import RankEdit from '@/components/RankEdit'
import Cemeteries from '@/components/Cemeteries'
import Cemetery from '@/components/Cemetery'
import CemeteryCreate from '@/components/CemeteryCreate'
import CemeteryEdit from '@/components/CemeteryEdit'
import Place from '@/components/Place'
import Places from '@/components/Places'
import Codes from '@/components/Codes'
import EditorReports from '@/components/EditorReports'
import EditorReportsPeople from '@/components/EditorReportsPeople'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/people',
      name: 'people',
      component: People
    },
    {
      path: '/unit/:id',
      name: 'unit',
      component: Unit
    },
    {
      path: '/units',
      name: 'units',
      component: Units
    },
    {
      path: '/unitCreate',
      name: 'unit-create',
      component: UnitCreate
    },
    {
      path: '/unitEdit/:id',
      name: 'unit-edit',
      component: UnitEdit
    },    
    {
      path: '/rank/:rankType/:id',
      name: 'rank',
      component: Rank
    },    
    {
      path: '/ranks',
      name: 'ranks',
      component: Ranks
    },
    {
      path: '/rankCreate',
      name: 'rank-create',
      component: RankCreate
    },
    {
      path: '/rankEdit/:rankType/:id',
      name: 'rank-edit',
      component: RankEdit
    }, 
    {
      path: '/cemeteries',
      name: 'cemeteries',
      component: Cemeteries
    },
    {
      path: '/cemeteryCreate',
      name: 'cemetery-create',
      component: CemeteryCreate
    },    
    {
      path: '/cemetery/:id',
      name: 'cemetery',
      component: Cemetery
    },
    {
      path: '/cemeteryEdit/:id',
      name: 'cemetery-edit',
      component: CemeteryEdit
    }, 
    {
      path: '/person/:id',
      name: 'person',
      component: Person
    },
    {
      path: '/places',
      name: 'places',
      component: Places
    },    
    {
      path: '/place/:id',
      name: 'place',
      component: Place
    },
    {
      path: '/codes',
      name: 'codes',
      component: Codes
    },      
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    }, 
    {
      path: '/about',
      name: 'about',
      component: About
    }, 
    {
      path: '/editorReports',
      name: 'editorReports',
      component: EditorReports
    },    
    {
      path: '/editorReportsPeople',
      name: 'editorReportsPeople',
      component: EditorReportsPeople
    },  
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '*',
      redirect: 'people'
    }    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js